(ns ui.data-grid.core
  (:require
   ["ag-grid-community" :refer [AllCommunityModule ModuleRegistry]]
   [applied-science.js-interop :as j]))

(defonce community-modules-registered?
  (do (j/call ModuleRegistry :registerModules #js [AllCommunityModule])
      true))
